export const SET_DATA_DEFAULT_USER = 'SET_DATA_DEFAULT_USER'
export const SET_DATA_MEMBER_USER = 'SET_DATA_MEMBER_USER'
export const INIT_DATA_USER_DEFAULT = 'INIT_DATA_USER_DEFAULT'
export const INIT_DATA_USER_MEMBER = 'INIT_DATA_USER_MEMBER'
